<template>
    <section class="mt-16">
      <v-row>
        <v-col cols="12" offset="0" md="10" offset-md="1">    
        <v-breadcrumbs
          large
          :items="crumbs"
          divider="/"
          class="pl-0"
        ></v-breadcrumbs>
  
        <h1 class="primary--text">
          <v-icon color="primary">mdi-account-hard-hat</v-icon> <span>Criar avaliação de fornecedor</span>
        </h1>
  
        <div class="mt-16">
          <SupplierEvaluation method="create"></SupplierEvaluation>
        </div>
        </v-col>
        </v-row>
    </section>
  </template>
  <script>
  import SupplierEvaluation from '@/components/supplier_evaluation/Evaluation.vue'
  
  export default {
    components: {
        SupplierEvaluation
    },
    beforeCreate(){
      document.title = "ODC - Criar avaliação de fornecedor";
    },
    data: () => ({
      
    }),
    mounted(){
      if(!this.$store.getters.hasPermission(["super", "supplier_evaluations.write"])) {
        this.$router.push('/forbidden');
      }
  
    },
    methods:{
    },
    computed: {
      crumbs: function() {
        return [
          {
            text: 'Dashboard',
            disabled: false,
            to: '/dashboard',
            exact: true,
          },
          {
            text: 'Avaliações',
            disabled: false,
            to: '/evaluations',
            exact: true,
          },
          {
            text: 'Criar avaliação de fornecedor',
            disabled: true,
            to: window.location.href,
            exact: true,
          },
        ];
      }
    }
  };
  </script>
  